import { useState } from 'react';

import { capitalizeEveryWord, removeSpecialChars } from '../utils/string';
import { isDynamicThemeEnabled } from './config';
import { useThemeSwitcher } from './useThemeSwitcher';

interface ThemeButton {
  text: string;
  handler?: () => void;
  role?: 'cancel' | 'destructive';
}

export const useThemeManager = () => {
  const { theme, loading, currentThemeName, availableThemes, switchToTheme } =
    useThemeSwitcher();

  const [isThemeSelectorOpen, setIsThemeSelectorOpen] = useState<boolean>(false);

  const openThemeSelector = () => setIsThemeSelectorOpen(true);
  const closeThemeSelector = () => setIsThemeSelectorOpen(false);

  const themeButtons: ThemeButton[] = [
    ...availableThemes.map((themeName) => {
      const isActive = themeName === currentThemeName;
      const label = capitalizeEveryWord(removeSpecialChars(themeName));

      return {
        text: isActive ? `✅ ${label}` : label,
        handler: () => switchToTheme(themeName),
      };
    }),
    { text: 'Cancelar', role: 'cancel' },
  ];

  return {
    // Theme data
    theme,
    loading,
    currentThemeName,
    availableThemes,

    // Theme selector state & handlers
    isThemeSelectorOpen,
    openThemeSelector,
    closeThemeSelector,
    themeButtons,

    // Direct theme switching
    switchToTheme,

    // Config flags
    isDynamicThemeEnabled,
  };
};
